var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftOfficeOutlook2018Present1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_1505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.175 9.45C20.1761 9.2987 20.0979 9.15787 19.9689 9.07875H19.9667L19.9586 9.07425L13.2536 5.10526C13.2246 5.0857 13.1946 5.06781 13.1636 5.05171C12.9047 4.91815 12.5972 4.91815 12.3383 5.05171C12.3073 5.06783 12.2772 5.0857 12.2483 5.10526L5.54328 9.07425L5.53518 9.07875C5.33026 9.20619 5.26744 9.47563 5.39487 9.68055C5.43242 9.74093 5.48413 9.79124 5.54553 9.8271L12.2505 13.7961C12.2796 13.8155 12.3096 13.8334 12.3405 13.8497C12.5994 13.9832 12.9069 13.9832 13.1658 13.8497C13.1967 13.8334 13.2268 13.8155 13.2558 13.7961L19.9608 9.8271C20.0948 9.74901 20.1765 9.60506 20.175 9.45Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32491 6.79995H10.725V10.8333H6.32491V6.79995ZM19.275 2.7V0.854996C19.2856 0.393703 18.9204 0.0110536 18.4592 0H7.04087C6.57958 0.0110536 6.21445 0.393703 6.22502 0.854996V2.7L12.975 4.49999L19.275 2.7Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22504 2.70001H10.725V6.75001H6.22504V2.70001Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.225 2.70001H10.725V6.75001L15.225 10.8H19.275V6.75001L15.225 2.70001Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.725 6.75H15.225V10.8H10.725V6.75Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.725 10.8H15.225V14.85H10.725V10.8Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32489 10.8333H10.725V14.4999H6.32489V10.8333Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.225 10.8H19.275V14.85H15.225V10.8Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9689 9.80236L19.9604 9.80687L13.2554 13.5779C13.2261 13.5959 13.1964 13.613 13.1653 13.6283C13.0515 13.6825 12.9278 13.7131 12.8018 13.7183L12.4355 13.5041C12.4045 13.4885 12.3744 13.4712 12.3454 13.4523L5.55046 9.57421H5.54731L5.32501 9.45001V17.0838C5.32848 17.5931 5.74405 18.0032 6.25336 18H19.261C19.2687 18 19.2754 17.9964 19.2835 17.9964C19.3911 17.9895 19.4972 17.9674 19.5985 17.9307C19.6423 17.9122 19.6846 17.8902 19.725 17.865C19.7551 17.8479 19.8069 17.8106 19.8069 17.8106C20.0374 17.64 20.1739 17.3706 20.175 17.0838V9.45001C20.1748 9.59602 20.0961 9.73065 19.9689 9.80236Z",
    fill: "url(#paint0_linear_298_1505)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.815 9.41983V9.88783L12.804 14.715L5.5455 9.57733C5.5455 9.57485 5.54348 9.57283 5.541 9.57283L4.875 9.17233V8.83482L5.1495 8.83032L5.73 9.16333L5.74349 9.16783L5.79299 9.19933C5.79299 9.19933 12.615 13.0918 12.633 13.1008L12.894 13.2538C12.9165 13.2448 12.939 13.2358 12.966 13.2268C12.9795 13.2178 19.7385 9.41532 19.7385 9.41532L19.815 9.41983Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9689 9.80236L19.9603 9.80731L13.2553 13.5783C13.2261 13.5963 13.1964 13.6134 13.1653 13.6287C12.9049 13.7559 12.6004 13.7559 12.34 13.6287C12.3092 13.6134 12.2792 13.5966 12.25 13.5783L5.54506 9.80731L5.53696 9.80236C5.40751 9.73218 5.32635 9.59726 5.32501 9.45001V17.0838C5.32824 17.593 5.74365 18.0032 6.25287 18C6.25287 18 6.25289 18 6.25291 18H19.2471C19.7563 18.0033 20.1718 17.5931 20.175 17.0839C20.175 17.0839 20.175 17.0838 20.175 17.0838V9.45001C20.1748 9.59602 20.0961 9.73065 19.9689 9.80236Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.353 13.5225L13.2527 13.5787C13.2236 13.5972 13.1935 13.6142 13.1627 13.6296C13.0521 13.6838 12.9319 13.7156 12.809 13.7232L15.36 16.74L19.8101 17.8123C19.932 17.7202 20.029 17.5991 20.0922 17.46L13.353 13.5225Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M13.8075 13.2669L13.2527 13.5788C13.2236 13.5973 13.1935 13.6143 13.1627 13.6296C13.0521 13.6839 12.9319 13.7157 12.809 13.7232L14.0042 17.0186L19.8114 17.811C20.0402 17.6392 20.1749 17.3699 20.175 17.0838V16.9852L13.8075 13.2669Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26551 18H19.2457C19.4455 18.001 19.6403 17.9379 19.8015 17.82L12.435 13.505C12.404 13.4894 12.374 13.4722 12.345 13.4532L5.55001 9.57511H5.54686L5.32501 9.45001V17.0577C5.32451 17.5776 5.74558 17.9995 6.26551 18Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.625 4.42482V14.0233C11.6242 14.3599 11.4196 14.6623 11.1075 14.7883C11.0108 14.8299 10.9067 14.8513 10.8015 14.8513H5.32501V4.04997H6.22501V3.59998H10.8015C11.2561 3.6017 11.624 3.97021 11.625 4.42482Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.175 4.87487V14.4734C11.1761 14.5821 11.1531 14.6897 11.1075 14.7884C10.9825 15.0964 10.6839 15.2985 10.3515 15.3H5.32501V4.05003H10.3515C10.4821 4.04872 10.6108 4.08128 10.725 4.14453C11.0009 4.2835 11.1749 4.56599 11.175 4.87487Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.175 4.87487V13.5734C11.1728 14.0278 10.8059 14.3961 10.3515 14.4H5.32501V4.05003H10.3515C10.4821 4.04872 10.6108 4.08128 10.725 4.14453C11.0009 4.2835 11.1749 4.56599 11.175 4.87487Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.725 4.87483V13.5733C10.7245 14.0284 10.3566 14.3978 9.90151 14.4H5.32501V4.04999H9.9015C10.3566 4.05023 10.7252 4.41933 10.725 4.87439C10.725 4.87454 10.725 4.87469 10.725 4.87483Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64986 4.04999H9.90015C10.3557 4.04999 10.725 4.41929 10.725 4.87483V13.1251C10.725 13.5807 10.3557 13.95 9.90015 13.95H1.64986C1.1943 13.95 0.825012 13.5807 0.825012 13.1251V4.87483C0.825012 4.41929 1.19431 4.04999 1.64986 4.04999Z",
    fill: "url(#paint1_linear_298_1505)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.40306 7.50961C3.60636 7.07647 3.9345 6.714 4.34537 6.46877C4.80037 6.20827 5.31844 6.0784 5.84252 6.09346C6.32826 6.08292 6.80756 6.20606 7.22807 6.44941C7.62344 6.68519 7.94187 7.03066 8.14471 7.4439C8.36562 7.89926 8.47571 8.40039 8.46602 8.9064C8.47672 9.43523 8.36345 9.95922 8.13527 10.4364C7.9276 10.8644 7.59906 11.2222 7.19027 11.4655C6.75354 11.7164 6.25645 11.8427 5.75297 11.831C5.25686 11.8429 4.76699 11.7184 4.33682 11.4709C3.93802 11.2349 3.6156 10.889 3.40802 10.4746C3.18581 10.0259 3.0744 9.53038 3.08312 9.0297C3.07387 8.50537 3.18324 7.98573 3.40306 7.50961ZM4.40746 9.9531C4.51585 10.2269 4.69967 10.4644 4.93756 10.638C5.17987 10.8074 5.47003 10.8947 5.76556 10.8873C6.08029 10.8998 6.39052 10.8094 6.64936 10.6299C6.88424 10.4569 7.06323 10.2187 7.16416 9.945C7.27698 9.6393 7.33267 9.31547 7.32841 8.98965C7.33189 8.66072 7.27955 8.33358 7.1736 8.02216C7.08003 7.74099 6.90682 7.49305 6.67501 7.30846C6.42266 7.12046 6.11326 7.02511 5.79886 7.03846C5.49692 7.03064 5.20027 7.1187 4.95151 7.29001C4.70959 7.46433 4.52229 7.70392 4.41151 7.98075C4.16576 8.61532 4.16448 9.31855 4.40791 9.954L4.40746 9.9531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.225 2.70001H19.275V6.75001H15.225V2.70001Z",
    fill: "#50D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_1505",
    x1: 12.75,
    y1: 9.45001,
    x2: 12.75,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_298_1505",
    x1: 2.54484,
    y1: 3.40547,
    x2: 9.00517,
    y2: 14.5945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_1505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.35,
    height: 18,
    fill: "white",
    transform: "translate(0.825012)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftOfficeOutlook2018Present1);
export default __webpack_public_path__ + "static/media/Microsoft_Office_Outlook_(2018–present) 1.2a498562c38ee3e33c25ead259a2bc7a.svg";
export { ForwardRef as ReactComponent };